import { create } from "zustand";
import { persist } from "zustand/middleware";
import { UserModelJsonResource } from "@/types/userTypes";

interface AuthState {
  token: string | null;
  user: UserModelJsonResource | null;
  setToken: (token: string) => void;
  setUser: (user: UserModelJsonResource) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setToken: (token: string) => set({ token }),
      setUser: (user: UserModelJsonResource) => set({ user }),
      logout: () => set({ token: null, user: null }),
    }),
    {
      name: "auth", // key in localStorage
    }
  )
);
